import reduceReducers from 'reduce-reducers';
import { googleAdsReducer } from 'redux-implementations/googleAds';
import { carGurusAdsReducer } from 'redux-implementations/carGurusAds';
import { MakeStore, HYDRATE } from 'next-redux-wrapper';
import {
  configureStore,
  getDefaultMiddleware,
  combineReducers,
  AnyAction,
  Reducer,
} from '@reduxjs/toolkit';
import createSagaMiddleware from 'redux-saga';
import { rootSaga } from 'redux-implementations/sagas';
import { sessionReducer } from 'redux-implementations/session';
import State, { RequestStates } from 'types/State';
import { reducer as makesAndModelsReducer } from './makesAndModels';
import { userReducer } from './user';
import { dialogReducer } from './dialog';
import { alertReducer } from './alerts';
import { geolocationReducer } from './geolocation';
import { favoritesReducer } from './favorites';
import { leadsReducer } from './leads';
import { utmTrackingReducer } from './utmTracking';
import { firstVisitTrackingReducer } from './firstVisitTracking';
import { leadSubmissionsReducer } from './leadSubmissions';
import { srpFiltersReducer, srpFiltersInitialState } from './srpFilters';

export const initialState: State = {
  leadSubmissions: [],
  user: {},
  makesAndModels: [],
  utmTracking: {},
  firstVisitTracking: {},
  session: {
    hasClosedAdhesionAd: false,
    isSignedIn: false,
    isPaid: false,
  },
  ads: {
    adUnit: null,
    targeting: {},
    slots: [],
    suggestiveSellingAds: [],
  },
  carGurusAds: {
    adUnit: null,
    targeting: {},
  },
  favorites: {
    byVin: {},
    allVins: [],
    requestState: RequestStates.Unstarted,
  },
  leads: {
    leads: [],
  },
  alerts: [],
  dialog: {},
  geolocation: null,
  srpFilters: srpFiltersInitialState,
};

const sliceReducers = combineReducers<State>({
  makesAndModels: makesAndModelsReducer,
  session: sessionReducer,
  ads: googleAdsReducer,
  carGurusAds: carGurusAdsReducer,
  user: userReducer,
  favorites: favoritesReducer,
  leads: leadsReducer,
  dialog: dialogReducer,
  alerts: alertReducer,
  geolocation: geolocationReducer,
  utmTracking: utmTrackingReducer,
  firstVisitTracking: firstVisitTrackingReducer,
  leadSubmissions: leadSubmissionsReducer,
  srpFilters: srpFiltersReducer,
});

function crossSliceReducer(state: State, action: AnyAction): State {
  switch (action.type) {
    // We may need to refine this logic if there are any race conditions that appear
    case HYDRATE: {
      return { ...state, ...action.payload };
    }
    default:
      return state;
  }
}

const makeStore: MakeStore = function storeMaker() {
  const sagaMiddleware = createSagaMiddleware();

  const store = configureStore({
    middleware: [sagaMiddleware, ...getDefaultMiddleware()],
    reducer: reduceReducers<State>(initialState, sliceReducers, crossSliceReducer) as Reducer,
  });

  sagaMiddleware.run(rootSaga);

  return store;
};

export default makeStore;
